module.exports = __webpack_public_path__ + "static/media/14UNEP21.03735615.jpg";